document.addEventListener('DOMContentLoaded', () => {
    const addShowMoreButtonListeners = () => {
        const sections = document.querySelectorAll(".section-staff");
        if (sections) {
            sections.forEach((section, index) => {
                const button = section.querySelector('.staff-show-more');
                if (button) {
                    button.setAttribute('data-index', index + 1);
                }
            })
        }


        sections.forEach((section) => {
            const button = section.querySelector(".staff-show-more");
            if (button) {
                button.addEventListener('click', async (event) => {
                    const button = event.target;
                    button.classList.add('btn-loading');
                    const parent = button.parentElement;

                    const postId = button.getAttribute('data-post-id');
                    const number = parseInt(button.getAttribute('data-number'));
                    const offset = parseInt(button.getAttribute('data-offset'));
                    const index = button.getAttribute('data-index');
                    const count = button.getAttribute('data-count');

                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Cache-Control': 'no-cache',
                        },
                        mode: 'no-cors',
                    };

                    const form = new FormData();
                    form.append('action', 'load_more_staff_one');
                    form.append('post_id', postId);
                    form.append('number', number);
                    form.append('offset', offset);
                    form.append('index', index);

                    const params = new URLSearchParams(form);
                    options.body = params;

                    try {
                        let response = await fetch('/wp-admin/admin-ajax.php', options);
                        let html = await response.text();
                        if (html) {
                            const peopleList = section.querySelector('.section-staff-one-list');
                            const lang = offset + number;
                            const total = parseInt(count, 10);

                            peopleList.insertAdjacentHTML('beforeend', html);

                            if (lang >= total) {
                                parent.remove();
                            } else {
                                button.setAttribute('data-offset', lang);
                                button.classList.remove('btn-loading');
                            }
                        }
                    } catch (error) {
                        console.error('Ошибка при загрузке сотрудников:', error);
                    }
                });
            }
        });
    };

    addShowMoreButtonListeners();
});
